var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.401C12.3407 22.401 12.6719 22.2811 12.9286 22.0603C13.898 21.2349 14.8338 20.4574 15.6569 19.7736L15.6617 19.7712C18.0804 17.7628 20.168 16.0303 21.6197 14.3219C23.2442 12.4118 24 10.6026 24 8.6254C24 6.70339 23.3233 4.93254 22.0972 3.6344C20.8542 2.32186 19.1506 1.59961 17.2957 1.59961C15.9112 1.59961 14.6419 2.02672 13.5237 2.86656C12.9598 3.29127 12.4487 3.81197 12 4.41665C11.5489 3.80957 11.0402 3.29127 10.4763 2.86656C9.35813 2.02672 8.09118 1.60201 6.70426 1.60201C4.85183 1.60201 3.14577 2.32426 1.90282 3.6368C0.674265 4.93494 0 6.70579 0 8.6278C0 10.605 0.755849 12.4142 2.38032 14.3243C3.83203 16.0327 5.92202 17.7652 8.33833 19.7736C9.16377 20.4598 10.102 21.2373 11.0714 22.0651C11.3281 22.2811 11.6593 22.401 12 22.401Z",
    fill: "#79B9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.1b4fb7e6b8f36b3fde53e63f76f02861.svg";
export { ForwardRef as ReactComponent };